<template lang="html">
  <div class="mb4 pv3 ph4 pl-box-shadow">
    <div class="row">
      <div class="col-xs center-xs title">
        <span>Time Spent on Parlay</span>
        <i
          class="fa fa-info-circle"
          style="color: #848484"
          aria-hidden="true"
          v-my-tooltip="time_spent_on_parlay_description"
        />
        <div class="nt4 end-xs">
          <pl-menu :menuSize="2" direction="right">
            <pl-button slot="menu_trigger" class="">
              {{ selected_filter }}
              <i class="fa fa-caret-down pa1" />
            </pl-button>
            <ul menu-content>
              <li
                v-for="(selected, index) in timeShown"
                :key="index"
                @click="selectFilter(selected)"
              >
                {{ selected }}
              </li>
            </ul>
          </pl-menu>
        </div>
      </div>
    </div>
    <canvas id="time-spent-on-parlay-graph-data"></canvas>
  </div>
</template>
<script>
  import Chart from 'chart.js';

  export default {
    watch: {
      analyticsTimeSpentOnParlay() {
        this.myLineChart.destroy();
        this.timeSpentOnParlayChartData();
      },
    },
    props: {
      analyticsTimeSpentOnParlay: {
        type: Array,
        default() {
          return [];
        },
      },
    },
    data() {
      return {
        timeShown: ['median', 'average'],
        selected_filter: 'median',
        myLineChart: [],
      };
    },
    computed: {
      time_spent_on_parlay_description() {
        return 'This chart shows the average amount of time that active teachers and students spent on Parlay in the dates selected.';
      },
    },
    methods: {
      timeSpentOnParlayChartData() {
        const payload = {
          type: 'line',
          data: [],
        };
        const array = [];
        if (
          this.analyticsTimeSpentOnParlay &&
          this.analyticsTimeSpentOnParlay.length
        ) {
          const month = this.analyticsTimeSpentOnParlay.map((label) => {
            const [year, month] = label.month.split('T')[0].split('-');

            return `${month}/${year}`;
          });
          payload.data.labels = month;

          let teachers_total = [];
          let students_total = [];
          if (this.selected_filter === 'median') {
            teachers_total = this.analyticsTimeSpentOnParlay.map(
              (data) => data.activity.teachers_total_minutes_median
            );
            students_total = this.analyticsTimeSpentOnParlay.map(
              (data) => data.activity.students_total_minutes_median
            );
          } else {
            teachers_total = this.analyticsTimeSpentOnParlay.map(
              (data) => data.activity.teachers_total_minutes_average
            );
            students_total = this.analyticsTimeSpentOnParlay.map(
              (data) => data.activity.students_total_minutes_average
            );
          }

          array.push(
            {
              label: 'Per Active Teacher',
              fill: false,
              tension: 0,
              borderColor: '#eb2d7C',
              backgroundColor: '#eb2d7C',
              data: teachers_total,
            },
            {
              label: 'Per Active Student',
              fill: false,
              tension: 0,
              borderColor: 'green',
              backgroundColor: 'green',
              data: students_total,
            }
          );
          (payload.data.datasets = array),
            (payload.options = {
              responsive: true,
              tension: 0,
              legend: {
                onHover: function (e) {
                  e.target.style.cursor = 'pointer';
                },
                labels: {
                  usePointStyle: true,
                  boxWidth: 7,
                },
              },
              tooltips: {
                xPadding: 25,
                yPadding: 15,
                titleAlign: 'center',
                footerAlign: 'center',
                bodyAlign: 'center',
                backgroundColor: '#fff',
                titleFontColor: '#595959',
                bodyFontColor: '#595959',
                footerFontColor: '#595959',
                borderWidth: 0.2,
                borderColor: '#595959',
                callbacks: {
                  label: function (tooltipItem, data) {
                    const total_minutes =
                      data.datasets[tooltipItem.datasetIndex].data[
                        tooltipItem.index
                      ];
                    const hours = Math.floor(total_minutes / 60);
                    const minutes = total_minutes % 60;
                    return hours + 'h ' + minutes.toFixed(0) + 'm';
                  },
                  footer: function (tooltipItem, data) {
                    return [
                      'Time on Parlay',
                      data.datasets[tooltipItem[0].datasetIndex].label,
                    ];
                  },
                },
                bodyFontSize: 30,
                displayColors: false,
              },
              hover: {
                onHover: function (e) {
                  var point = this.getElementAtEvent(e);
                  if (point.length) e.target.style.cursor = 'pointer';
                  else e.target.style.cursor = 'default';
                },
              },
            });
        }
        const ctx = document.getElementById('time-spent-on-parlay-graph-data');
        this.myLineChart = new Chart(ctx, payload);
      },
      selectFilter(selected) {
        this.selected_filter = selected;
        this.myLineChart.destroy();
        this.timeSpentOnParlayChartData();
      },
    },
    mounted() {
      this.timeSpentOnParlayChartData();
    },
  };
</script>
<style scoped lang="stylus">
  .title
    margin: 0 0 10px 0
    span
      margin-right: 10px
      font-size: 18px
      font-weight: 600
</style>



// WEBPACK FOOTER //
// timeSpentOnParlayGraph.vue?676c9eff